module.exports = __webpack_public_path__ + "img/item1-6.064c914b.png";